var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M12.422 20.523h12.896"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.874,
    cy: 20.463,
    r: 1.696
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.54 26.113l-5.59-5.59 5.59-5.589"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingpayment);
export default __webpack_public_path__ + "static/media/incomingpayment.edd9e5c4fc66f489a8a843259ddb58a3.svg";
export { ForwardRef as ReactComponent };